import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import bbhLogoUrl from '@/assets/bbh-logo-on-dark.svg';
import './DesktopNav.css';

const DesktopNav: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/people', label: 'People', icon: '👥' },
    { path: '/companies', label: 'Companies', icon: '🏢' },
    { path: '/projects', label: 'Projects', icon: '📁' },
    { path: '/ew-tools', label: 'EW Tools', icon: '🛠️' },
    { path: '/docs', label: 'Docs', icon: '📖' },
    { path: '/settings', label: 'Settings', icon: '⚙️' },
  ];

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <nav className="desktop-nav">
      <div className="desktop-nav-header">
        <img className="desktop-nav-logo" src={bbhLogoUrl} alt="Backed by Humans" />
      </div>

      <ul className="desktop-nav-list">
        {navItems.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `desktop-nav-link ${isActive ? 'active' : ''}`
              }
            >
              <span className="desktop-nav-icon">{item.icon}</span>
              <span className="desktop-nav-label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="desktop-nav-footer">
        {user && (
          <div className="desktop-nav-user">
            <span className="desktop-nav-user-name">{user.full_name}</span>
            <span className="desktop-nav-user-email">{user.email}</span>
          </div>
        )}
        <button className="desktop-nav-logout" onClick={handleLogout}>
          <span className="desktop-nav-icon">🚪</span>
          <span className="desktop-nav-label">Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default DesktopNav;
